export const graphsDimensions = {
  width: 484,
  height: 372,
};
